import styled, { css } from "styled-components";

import {
  ACCENT_PRIMARY_LIGHTEST,
  ACCENT_PRIMARY_LIGHTEST_HOVER,
  ACCENT_PRIMARY_LIGHTEST_PRESSED,
  ACCENT_SECONDARY_LIGHTEST,
  ACCENT_SECONDARY_LIGHTEST_HOVER,
  ACCENT_SECONDARY_LIGHTEST_PRESSED,
  GRAY_LIGHT,
  GRAY_LIGHTEST,
  GRAY_LIGHTEST_HOVER,
  GRAY_LIGHTEST_PRESSED,
  WHITE
} from "../../colors";
import { LARGE_SCREEN } from "../../constants/screenSizes";
import { Body, SecondarySmall } from "../../typography";
import calloutCardThemes from "../constants/calloutCardThemes";
import imagePositions from "../constants/imagePositions";

const themeStyles = {
  [calloutCardThemes.BLUE]: css`
    background: ${ACCENT_PRIMARY_LIGHTEST};
  `,
  [calloutCardThemes.ORANGE]: css`
    background: ${ACCENT_SECONDARY_LIGHTEST};
  `,
  [calloutCardThemes.GRAY]: css`
    background: ${GRAY_LIGHTEST};
  `,
  [calloutCardThemes.WHITE]: css`
    background: ${WHITE};
    border-color: ${GRAY_LIGHT};
  `
};

const interactiveThemeStyles = {
  [calloutCardThemes.BLUE]: css`
    &:hover {
      background: ${ACCENT_PRIMARY_LIGHTEST_HOVER};
    }

    &:active {
      background: ${ACCENT_PRIMARY_LIGHTEST_PRESSED};
    }
  `,
  [calloutCardThemes.ORANGE]: css`
    &:hover {
      background: ${ACCENT_SECONDARY_LIGHTEST_HOVER};
    }

    &:active {
      background: ${ACCENT_SECONDARY_LIGHTEST_PRESSED};
    }
  `,
  [calloutCardThemes.GRAY]: css`
    &:hover {
      background: ${GRAY_LIGHTEST_HOVER};
    }

    &:active {
      background: ${GRAY_LIGHTEST_PRESSED};
    }
  `,
  [calloutCardThemes.WHITE]: css`
    &:hover {
      background: ${WHITE};
    }
  `
};

export const CallToAction = styled.span`
  margin-top: 10px;
`;

export const ContentWrapper = styled.span`
  @media screen and (max-width: ${LARGE_SCREEN}px) {
    width: 100%;
  }
`;

export const Description = styled(Body).attrs({ as: "span" })`
  display: block;
  margin-top: 4px;
`;

export const Headline = styled(SecondarySmall).attrs({
  as: "span"
})`
  display: block;
`;

export const HorizontalCardWrapper = styled.div`
  align-items: center;
  border: 1px solid transparent;
  border-radius: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;
  cursor: ${({ interactive }) => (interactive ? "pointer" : "default")};
  display: flex;
  margin: 0;
  padding: 15px 19px;
  text-align: left;
  text-decoration: none;
  transition: background 250ms, box-shadow 250ms;
  width: 100%;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    align-items: flex-start;
    flex-direction: column;
    padding: 19px;
  }

  ${({ theme }) => themeStyles[theme]}

  ${({ interactive, theme }) =>
    interactive &&
    css`
      &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      }

      &:active {
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
      }

      ${interactiveThemeStyles[theme]}
    `}

  * {
    box-sizing: border-box;
  }
`;

export const IllustrationWrapper = styled.span`
  padding-right: 24px;

  img {
    display: block;
  }

  @media screen and (min-width: ${LARGE_SCREEN}px) {
    ${({ imagePosition }) =>
      imagePosition === imagePositions.RIGHT &&
      css`
        margin-left: auto;
        order: 1;
        padding: 0 0 0 24px;
      `}
  }

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    padding: 0 0 20px;
  }
`;
